import { connect } from 'react-redux'

import { isOwnerOnboardingActive } from 'screens/OnboardingPopover/utils'
import { isOnboardingOnInviteStep } from 'screens/OnboardingPopover/utils'

export default connect(state => ({
  isOwnerOnboardingActive: isOwnerOnboardingActive(state),
  isOnboardingOnInviteStep: isOnboardingOnInviteStep(state),
}))
